<template>
  <div class="wrap-logo">
    <div class="logo-s">
      <div class="box-logo">
        <img src="../../assets/images/aaa.png">
      </div>
      <img class="aat-logo" src="../../assets/images/aat_logo.jpg">
    </div>

    <div class="logo-lg">
      <b-container>
        <div class="box-logo">
          <img class="tablet" src="../../assets/images/aaa.png">
          <img class="desktop" src="../../assets/images/admans_logo.png">
        </div>
        <img class="aat-logo" src="../../assets/images/aat_logo.jpg">

        <a href="https://www.facebook.com/admanawards/" target="_blank">
          <img src="../../assets/icons/facebook-brands.svg">
        </a>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerUrls: [
        '../../assets/images/banner-01.gif',
        '../../assets/images/banner-01.gif'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-logo {
  .logo-s {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .box-logo {
      width: 90px;
      height: auto;
      background-color: $active;

      img {
        margin-left: -1px;
        height: 55px;
      }
    }

    .aat-logo {
      height: 22px;
    }
  }

  .logo-lg {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
.wrap-logo {
  padding-top: 55px;

  .logo-s {
    display: none;
  }

  .logo-lg {
    display: block;

    height: 68px;
    background: linear-gradient(
      90deg, rgba(0,0,0,1) 0%,
      rgba(0,0,0,1) 5%,
      rgba(255,255,255,1) 5%,
      rgba(255,255,255,1) 100%
    );

    @media only screen and (min-width: 1024px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 20%,
        rgba(255,255,255,1) 20%,
        rgba(255,255,255,1) 100%
      );
    }

    @media only screen and (min-width: 1440px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 25%,
        rgba(255,255,255,1) 25%,
        rgba(255,255,255,1) 100%
      );
    }

    @media only screen and (min-width: 2245px) {
      background: linear-gradient(
        90deg, rgba(0,0,0,1) 0%,
        rgba(0,0,0,1) 30%,
        rgba(255,255,255,1) 30%,
        rgba(255,255,255,1) 100%
      );
    }

    .container {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .box-logo {
        width: 120px;
        height: 68px;
        background-color: $active;
        animation: boxLogo 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

        @media only screen and (min-width: 1024px) {
          width: 320px;
        }

        img {
          margin-left: -1px;
          height: 100%;
          animation: logo 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
        }

        .tablet {
          width: auto;
          height: 68px;
        }

        .desktop {
          display: none;
        }

        @media only screen and (min-width: 1024px) {
          .tablet {
            display: none;
          }

          .desktop {
            display: block;
          }
        }
      }

      .aat-logo {
        margin-left: 12px;
        height: 38px;
        border-right: 1px solid #ccc;
      }

      a {
        opacity: 0.3;
        position: absolute;
        left: calc(50% + 92px);
        // transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

        @media only screen and (min-width: 1024px) {
          left: calc(50% + 172px);
        }

        @media only screen and (min-width: 1200px) {
          left: calc(50% + 92px);
        }

        img {
          height: 32px;
        }
      }

      a:hover {
        opacity: 1;
      }
    }
  }
}
}

@keyframes boxLogo {
  0% {
    transform: translateX(-100px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes logo {
  0% {
    opacity: 0;
    transform: translateX(-150px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
